import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { reactive } from 'vue';
import {
  delete_order_used_cancel_record,
  query_person_to_costom_list,
  send_receipt,
} from '@/api/mjstore-model';
import { message, Modal, notification } from 'ant-design-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';

import modalBox from '@/components/form-modal/modal-tools';
import moment from 'moment';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '作废',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.is_active == true;
    },
    cb: (record: any) => {
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '作废',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '作废日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm:ss',
              valueFormat: 'YYYY-MM-DD HH:mm:ss',
              showTime: true,
              placeholder: '请选择作废时间',
            },
          ],
          rules: {
            shop_id: [{ required: true, message: '请选择执行门店' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
            date: [{ required: true, message: '请选择作废时间' }],
          },
          model: {
            org_id: current_org?.id,
            order_used_cancel_record_id: record.id,
            shop_id: current_shop?.id,
            staff_id: record.staff_id,
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            delete_order_used_cancel_record({
              ...payload,
              org_id: current_org?.id,
              order_used_cancel_record_id: record.id,
            })
              .then(() => {
                notification.success({
                  message: '成功',
                  description: '作废成功',
                });
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  // {
  //   name: '发送',
  //   clazz: 'primary',
  //   content: (record: any) => {
  //     return record.receipt_confirmed ? '已确认' : '发送';
  //   },
  //   disabled: (record: any) => {
  //     return !!record.receipt_confirmed;
  //   },
  //   cb: (record: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  //     query_person_to_costom_list({
  //       org_id: current_org?.id,
  //       customer_id: record.customer_id,
  //     }).then((res: any) => {
  //       if (res.data.length == 0 || (res.data.length > 0 && !res.data[0].name)) {
  //         Modal.warning({
  //           title: '提示',
  //           content: '会员尚未绑定，无法发送',
  //         });
  //       } else {
  //         Modal.confirm({
  //           title: '提示',
  //           content: `即将发送退货记录至客户公众号账号，是否继续发送（第${
  //             record.receipt_count + 1
  //           }次发送）`,
  //           onOk() {
  //             send_receipt({
  //               obj_id: record.id,
  //               business_type: 'OrderUsedCancelRecord',
  //               org_id: current_org?.id,
  //             }).then(res => {
  //               message.success('发送成功');
  //               Object.assign(record, res);
  //             });
  //           },
  //           onCancel() {},
  //         });
  //       }
  //     });
  //   },
  // },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
